var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 20,
    fill: "#EBF4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3587 27.8466C30.4102 26.7852 31.4897 25.7479 32.6148 24.7589C33.2843 23.7526 36.6665 22.2466 35.7623 21.0852C35.1769 20.1341 34.5215 18.7211 33.4209 18.373C30.8939 20.3994 28.535 22.605 26.2954 24.9208C21.2693 20.2788 17.1895 17.322 20.9924 22.5292C22.5731 23.4907 24.0487 24.5969 25.4507 25.7927C23.0953 28.2947 20.8732 30.9241 18.7422 33.619C18.7422 34.839 19.9128 36.0107 20.7295 36.8929C21.4796 37.72 22.17 35.7074 22.7764 35.2801C24.62 33.009 26.5267 30.7794 28.5526 28.6668C31.5072 31.5961 34.2446 34.7804 37.1923 37.627C37.8267 36.8068 33.7539 32.182 29.3587 27.8466Z",
    fill: "#213A68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderClose);
export default __webpack_public_path__ + "static/media/HeaderClose.68f94471714c18c94b344512b5707467.svg";
export { ForwardRef as ReactComponent };